var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M831.623425 912.042133A509.84892 509.84892 0 0 1 511.999317 1023.999317a509.917187 509.917187 0 0 1-319.589974-111.957184h639.214082z m161.348051-224.050901a510.190253 510.190253 0 0 1-57.582857 112.025451H88.644148A510.36092 510.36092 0 0 1 31.061292 687.957099h961.876051z m28.808495-223.982635a518.211576 518.211576 0 0 1-1.706664 111.991318H3.959461a517.051044 517.051044 0 0 1-1.774931-111.991318h1019.561308zM945.867539 239.957696a509.74652 509.74652 0 0 1 52.63353 112.025451H25.531699A509.678254 509.678254 0 0 1 78.165229 239.957696h867.70231zM512.033451 0.000683a510.05372 510.05372 0 0 1 338.636348 127.999829H173.328836A510.05372 510.05372 0 0 1 511.999317 0.000683z",
    fill: "#0076BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M935.354486 800.016683a514.764114 514.764114 0 0 1-103.731061 111.957184H192.37521a514.900647 514.900647 0 0 1-103.765195-111.957184h846.744471z m84.650554-224.016768a508.585989 508.585989 0 0 1-27.067697 111.991317H31.061292a508.688388 508.688388 0 0 1-27.101831-111.991317h1016.079712z m-21.503971-224.016768c11.946651 36.351952 19.72904 73.932701 23.278902 112.02545H2.218664c3.618129-38.775415 11.537051-76.253765 23.278902-111.991317h973.003503zM850.669799 128.000512c36.932217 32.59729 68.949241 70.314573 95.163607 111.991317H78.165229A514.593447 514.593447 0 0 1 173.294702 128.000512h677.340964z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M511.999317 0.000683c16.042645 0 32.051157 0.750932 47.991403 2.218663v557.772057H2.252797A518.382242 518.382242 0 0 1 0 512C0 229.239844 229.239161 0.000683 511.999317 0.000683z",
    fill: "#0076BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.008085 31.061975V239.957696h224.016768v112.025451H336.008085v223.982634H224.016768v-223.982634H25.497566A509.64412 509.64412 0 0 1 78.165229 239.957696h145.851539V88.644831A510.395053 510.395053 0 0 1 336.008085 31.061975z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEl);
export default __webpack_public_path__ + "static/media/el.78961817c0ac08cc35991f2c058c5458.svg";
export { ForwardRef as ReactComponent };